export default __webpack_public_path__ + "static/media/shoes10.6feacadb.jpeg";